/**
 * UranIA PA — RBAC helpers (US-028).
 *
 * Helper puri (no side-effects) per i route guard SPA che vogliono
 * mostrare/nascondere route admin in base ai ruoli del Principal Keycloak.
 *
 * Boundary:
 *   - Lato client la visibilità è UX, NON sicurezza: l'autorizzazione è
 *     server-side (US-007 step-up + step-up guard nelle route admin
 *     `services/api-gateway/src/api_gateway/routes/tenants.py`). Un
 *     utente che forza il path `/admin/...` senza ruolo riceve 403 dal
 *     API Gateway.
 *   - I ruoli sono letti da `principal.roles` (claim
 *     `realm_access.roles` normalizzato in `auth-store.ts` US-009).
 *   - Lista ruoli admin allineata letteralmente a quanto consumato dal
 *     `DashboardAdminConsoleWidget` (US-011).
 */

import type { UraniaPrincipal } from './auth-store.ts';

export const ROLE_PLATFORM_ADMIN = 'platform_admin';
export const ROLE_TENANT_ADMIN = 'tenant_admin';
export const ROLE_FUNZIONARIO_ADG = 'funzionario_adg';
export const ROLE_BENEFICIARIO_RI = 'beneficiario_ri';

export const ADMIN_ROLES: readonly string[] = [ROLE_PLATFORM_ADMIN, ROLE_TENANT_ADMIN];

export function principalIsFunzionario(principal: UraniaPrincipal | null): boolean {
  return principalHasRole(principal, ROLE_FUNZIONARIO_ADG);
}

export function principalIsBeneficiario(principal: UraniaPrincipal | null): boolean {
  return principalHasRole(principal, ROLE_BENEFICIARIO_RI);
}

export function principalHasRole(
  principal: UraniaPrincipal | null,
  role: string,
): boolean {
  if (principal === null) {
    return false;
  }
  return principal.roles.includes(role);
}

export function principalIsPlatformAdmin(principal: UraniaPrincipal | null): boolean {
  return principalHasRole(principal, ROLE_PLATFORM_ADMIN);
}

export function principalIsAnyAdmin(principal: UraniaPrincipal | null): boolean {
  if (principal === null) {
    return false;
  }
  return principal.roles.some((role) => ADMIN_ROLES.includes(role));
}
